import {
  FieldWrapper,
  FormTextField,
  GenericFormFieldHint,
} from "styles/formStyleComponents";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

const TextFieldComponent = ({
  name,
  label,
  placeholder,
  value,
  required,
  disabled,
  error,
  info,
  hint,
  hintId,
  onChange,
  onFieldBlur,
  validation = {},
  compact = false,
  inputProps: htmlInputProps = {},
  inputType,
  field = {},
}) => {
  const fieldLabel = required ? `${label}` : label;
  const resolvedHintId =
    hintId || field.hintId || (hint ? `${name}-hint` : undefined);

  const textField = (
    <FormTextField
      label={compact ? undefined : fieldLabel}
      variant="outlined"
      size="small"
      fullWidth
      type={inputType}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      autoComplete="off"
      value={value || ""}
      onChange={(e) => {
        const val = e.target.value;
        if (validation.maxLength && val.length > validation.maxLength) {
          return;
        }
        onChange(name, val);
      }}
      onBlur={(e) => {
        if (onFieldBlur) {
          onFieldBlur(name, e.target.value);
        }
      }}
      error={!!error}
      helperText={error}
      slotProps={{
        htmlInput: {
          maxLength: validation.maxLength,
          ...htmlInputProps,
        },
      }}
      InputProps={{
        endAdornment: <InfoIconWithTooltip info={info} />,
      }}
    />
  );

  const hintElement =
    hint && !error ? (
      <GenericFormFieldHint id={resolvedHintId} component="div">
        {hint}
      </GenericFormFieldHint>
    ) : null;

  if (compact) {
    return (
      <>
        {textField}
        {hintElement}
      </>
    );
  }

  return (
    <FieldWrapper>
      {textField}
      {hintElement}
    </FieldWrapper>
  );
};

export default TextFieldComponent;
